export function stonlyTrackFn(userId, customPropObj) {
  // eslint-disable-next-line no-undef
  stonlyTrack('identify', userId, customPropObj);
}
